const API_VER = 'v1.0'
export const LocationEndpoints = {
    SITE_URI: `/location/api/${API_VER}/sites/`,
    ZONE_URI: `/location/api/${API_VER}/zones/`,
}